module.exports = __webpack_public_path__ + "media/smart_sales/ss_photo_2-e0404dee.webp";